var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"srcset":(_vm.getImgUrl + " 1x," + _vm.getImgUrl2x + " 2x," + _vm.getImgUrl3x + " 3x"),"src":_vm.getImgUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }